module.exports = [
    {
        "title": "审核信息",
        "contents": [
            {
                "text": "年度财务审计报告",
                "links": [
                    {
                        "link": "五八钱柜审计报告-2018年",
                        "href": "//j1.58cdn.com.cn/jinrong/licai/pc/%E4%BA%94%E5%85%AB%E9%92%B1%E6%9F%9C%E5%AE%A1%E8%AE%A1%E6%8A%A5%E5%91%8A-2018%E5%B9%B4.pdf"
                    },
                    {
                        "link": "五八钱柜审计报告-2017年",
                        "href": "//j1.58cdn.com.cn/jinrong/licai/pc/%E4%BA%94%E5%85%AB%E9%92%B1%E6%9F%9C%E5%AE%A1%E8%AE%A1%E6%8A%A5%E5%91%8A-2017%E5%B9%B4.pdf"
                    },
                    {
                        "link": "五八钱柜审计报告-2016年",
                        "href": "//j1.58cdn.com.cn/jinrong/licai/pc/%E4%BA%94%E5%85%AB%E9%92%B1%E6%9F%9C%E5%AE%A1%E8%AE%A1%E6%8A%A5%E5%91%8A-2016%E5%B9%B4.pdf"
                    }
                ]
            },
            {
                "text": "重点环节审计结果",
                "link": "点击查看",
                "href": "//j1.58cdn.com.cn/jinrong/licai/pc/%E4%BA%94%E5%85%AB%E9%92%B1%E6%9F%9C%E9%87%8D%E7%82%B9%E7%8E%AF%E8%8A%82%E5%AE%A1%E8%AE%A1%E7%BB%93%E6%9E%9C.pdf"
            },
            {
                "text": "上一年度合规性审查报告",
                "link": "点击查看",
                "href": "//j1.58cdn.com.cn/jinrong/licai/pc/%E4%BA%94%E5%85%AB%E9%92%B1%E6%9F%9C%E5%90%88%E8%A7%84%E6%80%A7%E5%AE%A1%E6%9F%A5%E6%8A%A5%E5%91%8A.pdf?t=1"
            }
        ]
    }
]


// WEBPACK FOOTER //
// ./src/config/InfoDcs/Audit.js